// import {StrictMode} from 'react';
import ReactDOM from 'react-dom/client';
import './style/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// StrictMode fires createPaymentIntent twice when running locally
// This is not a production issue, but if desired you can take out the strictmode element entirely by deleting  <StrictMode>  &  </StrictMode>

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
